module.exports = __webpack_public_path__ + "img/logo-footer.7b874e48.png";